import { Card, Typography, Modal } from "antd";
import {
  PlusCircleOutlined,
  FileAddOutlined,
  ThunderboltOutlined,
  CheckCircleOutlined,
  MessageOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { useEffect, type CSSProperties } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { openMenuTab } from "../../../utils/menu/menutabs";

const { Title } = Typography;

const page: CSSProperties = {
  minHeight: "0",
  background: "#d6d2d24b",
  position: "relative",
};

const topTabs: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "12px 28px",
  margin: "5px 5px",
  padding: "16px 24px",
  borderRadius: 10,
  color: "#fff",
  backdropFilter: "blur(20px)",
  background: "#884699f3",
};

const tabItem: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "0px 10px",
  cursor: "pointer",
  transition: "all .3s",
};

const tabIcon: CSSProperties = {
  width: 38,
  height: 38,
  borderRadius: 12,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,

};

const contentCard: CSSProperties = {
  borderRadius: 12,
  border: "none",
  backgroundColor: "#ffffff52",
};

const Booking: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.replace("/booking/", "");

  const tabs = [
    {
      key: "add",
      label: "Add Booking",
      color: "#00d2a8",
      icon: <PlusCircleOutlined />,
      count: 0,
    },
    {
      key: "new",
      label: "New Bookings",
      color: "#ff9f1c",
      icon: <FileAddOutlined />,
      count: 14,
    },
    {
      key: "live",
      label: "Live Trips",
      color: "#3a86ff",
      icon: <ThunderboltOutlined />,
      count: 6,
    },
    {
      key: "completed",
      label: "Completed",
      color: "#2ecc71",
      icon: <CheckCircleOutlined />,
      count: 28,
    },
    {
      key: "enquiry",
      label: "Enquiries",
      color: "#9b59b6",
      icon: <MessageOutlined />,
      count: 9,
    },
    {
      key: "cancel",
      label: "Cancelled",
      color: "#ff4d6d",
      icon: <MinusCircleOutlined />,
      count: 3,
    },
  ];

  useEffect(() => {
    if (
      location.pathname === "/booking" ||
      location.pathname === "/booking/"
    ) {
      navigate("/booking/live", { replace: true });
      return;
    }

    if (!validTab) {
      Modal.error({
        title: "Invalid Page",
        content: `"${currentPath}" is not a valid booking page.`,
        okText: "Go to Bookings",
        onOk: () => navigate("/booking/live", { replace: true }),
      });
      navigate("/booking/live", { replace: true });
    }
  }, [location.pathname]);

  const validTab = tabs.some((t) => currentPath.includes(t.key));
  const currentTab = validTab ? currentPath.split("/")[0] : "";

  return (
    <div style={page}>

      <div style={topTabs}>
        {tabs.map((tab) => {
          const active = tab.key === currentTab;

          return (
            <div
              key={tab.key}
              onClick={() => {
                if (!active) openMenuTab(`/booking/${tab.key}`);
              }}
              style={{
                ...tabItem,
                cursor: active ? "default" : "pointer",
                borderBottom: active
                  ? `3px solid ${tab.color}`
                  : "3px solid transparent",
              }}
            >
              {/* <Badge count={tab.count} offset={[5, -5]}> */}
              <div
                style={{
                  ...tabIcon,
                  background: active ? tab.color : "#fff",
                  color: active ? "#fff" : tab.color,
                }}
              >
                {tab.icon}
              </div>
              {/* </Badge> */}

              <span style={{ fontWeight: active ? 700 : 500 }}>
                {tab.label}
              </span>
            </div>
          );
        })}
      </div>

      <Card style={contentCard}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </Card>
    </div>
  );
};

export default Booking;
